import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getAllRows } from "../ReportElementHelper";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class LiensJudgements extends Component {
  state = {
    rowTables: [],
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  loadData = (props) => {
    const rowTables = [];
    let recCount = 0;
    if (props.reportData !== undefined) {
      const { isSilverReport } = this.props;
      const lienJudgment = isSilverReport
        ? this.props.node
        : _.get(
            props.reportData,
            "personReport.compReportResponse[0].individual[0].liensJudgments[0].lienJudgment"
          );
      if (lienJudgment && lienJudgment.length > 0) {
        _.forEach(lienJudgment, (record, index) => {
          if (record) {
            const recs = [];
            if (isSilverReport)
              getAllRows(record, recs, props, _.get(record, "$.display"), 2);
            else getAllRows(record, recs, props, _.get(record, "$.display"));
            if (recs.length > 0) {
              rowTables.push(
                <Table.Row key={`lienJudgment_${index}`}>
                  <Table.Cell>
                    <Table>
                      <Table.Body>
                        <Table.Row>
                          <Table.HeaderCell
                            colSpan={2}
                            className="report-sub-section-header"
                          >
                            Record
                          </Table.HeaderCell>
                        </Table.Row>
                        {recs}
                      </Table.Body>
                    </Table>
                  </Table.Cell>
                </Table.Row>
              );
            }
          }
        });
        recCount = rowTables.length;
      } else {
        rowTables.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    }
    if (recCount < 1 && rowTables.length < 1) {
      rowTables.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rowTables });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Liens and Judgments"}
        rows={this.state.rowTables}
      />
    );
  }
}

export default LiensJudgements;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/LiensJudgements.js